import { AlloyButton, StickySection } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import styles from '../validInvalidPartsTable.module.scss';

const SISToCartModalActions = ({ close }) => {
  const { t } = useTranslation();
  return (
    <div className="bottom-0 position-sticky">
      <StickySection
        className={cx(
          'mt-2 px-3 align-items-center bg-white z-index-1 w-100',
          styles['modal__sticky-container']
        )}
      >
        <div className="d-flex flex-md-row-reverse flex-column py-3">
          <AlloyButton buttonType="primary" size="dynamic" type="submit">
            {t('REQUISITIONLIST_ACTION_ADD_TO_CART')}
          </AlloyButton>
          <AlloyButton
            size="dynamic"
            buttonType="ghost"
            onClick={() => close(true)}
            className="mt-md-0 mt-2 me-md-3 me-0"
          >
            {t('MO_CancelButton')}
          </AlloyButton>
        </div>
      </StickySection>
    </div>
  );
};

export default SISToCartModalActions;
SISToCartModalActions.propTypes = {
  close: PropTypes.func
};
